import { BusinessActivity } from "Infrastructure/Api/Api";
import type { CodeListItem } from "Models/ICodeListDto";
import { Resources, useResource } from "Translations/Resources";
import { useMemo } from "react";

type ListItem = CodeListItem<BusinessActivity>;
type Result = ListItem[];

const LEGACY_BUSINESS_ACTIVITIES: Array<BusinessActivity> = [
  BusinessActivity.RetailAndCommerce,
  BusinessActivity.FoodAndBeverageServices,
  BusinessActivity.AccommodationAndHospitality,
  BusinessActivity.BeautyAndPersonalCare,
  BusinessActivity.HealthcareAndPersonalCare,
  BusinessActivity.ConstructionAndMaintenance,
  BusinessActivity.TransportationAndLogistics,
  BusinessActivity.FinancialServicesAndInsurance,
  BusinessActivity.RealEstateAndPropertyServices,
  BusinessActivity.LegalAndConsultingServices,
  BusinessActivity.EducationAndTraining,
  BusinessActivity.ArtsCultureAndEntertainment,
  BusinessActivity.SportsAndRecreation,
  BusinessActivity.TechnologyAndITServices,
  BusinessActivity.ECommerceAndOnlineServices,
  BusinessActivity.IndustrialProductionAndProcessing,
  BusinessActivity.Other,
  BusinessActivity.PersonalServices,
];

type Options = {
  includeLegacy?: boolean;
};

export const useBusinessActivityList = (options?: Options) => {
  const { t } = useResource();
  const includeLegacy = options?.includeLegacy ?? false;

  return useMemo<Result>(
    () =>
      Object.entries(BusinessActivity)
        .filter(
          ([key]) =>
            includeLegacy ||
            !LEGACY_BUSINESS_ACTIVITIES.includes(key as BusinessActivity),
        )
        .map<ListItem>(([key]) => {
          const isLegacy = LEGACY_BUSINESS_ACTIVITIES.includes(
            key as BusinessActivity,
          );
          return {
            code: key as BusinessActivity,
            name: isLegacy
              ? `${t(Resources.Form.BusinessActivity[key as BusinessActivity])} (${t(Resources.Common.Unsupported)})`
              : t(Resources.Form.BusinessActivity[key as BusinessActivity]),
            disabled: isLegacy,
          };
        }),
    [t, includeLegacy],
  );
};
